import api from "./api";

const otpRecordsService = {
  list: async (token, params = {}, path = "/ssdi/otps") => {
    const res = await api.get(path, {
      params,
      headers: { Authorization: `Bearer ${token}` },
    });
    return res.data;
  },
};

export default otpRecordsService;
